import { Link } from 'react-router-dom';
import { navigation } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-quill-pen-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-50 tracking-tight">
                一起草
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400">
              让创作更简单，让表达更有力。一起草致力于用AI技术赋能每一位创作者。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-100 font-heading font-semibold mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              {navigation.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 font-heading font-semibold mb-4 text-sm">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/feature-guide" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer">功能指南</Link>
              </li>
              <li>
                <Link to="/category/tutorial" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer">使用教程</Link>
              </li>
              <li>
                <Link to="/category/news" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer">最新动态</Link>
              </li>
              <li>
                <Link to="/category/faq" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer">常见问题</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 font-heading font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line mt-0.5"></i>
                <span>support@yiqicao.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line mt-0.5"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>北京市海淀区中关村科技园区创新路88号</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 一起草 版权所有 | 
            <a href="/privacy" className="hover:text-foreground-300 ml-1 transition-colors cursor-pointer">隐私政策</a>
            <span className="mx-1">|</span>
            <a href="/terms" className="hover:text-foreground-300 transition-colors cursor-pointer">服务条款</a>
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="GitHub">
              <i className="ri-github-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}